import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
        });

        // data-scroll-event-progress
        window.addEventListener('progressEvent', (e) => {
            const { target, progress } = e.detail;

            if (target && progress) {
                target.style.opacity = 1 - progress*2;
            }
        });
    }

    destroy() {
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
        window.removeEventListener('progressEvent', () => { });
    }
}
